import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales: ['de', 'fi', 'en', 'es'],
  defaultLocale: 'de',
  localePrefix: 'always',
  localeCookie: false,
  alternateLinks: false,
})
